/**
 * @description 根据Url下载文件，包括图片
 * @param {*} url
 * @param {*} fileName
 */
const downloadUrlFile = (data, fileName) => {
  // 创建当前时间字符串，生成文件名称时使用
  // const time = +new Date()
  if (!fileName) {
    let dis = data.headers['content-disposition']
    fileName = decodeURIComponent(dis.split('attachment;filename=')[1])
  }
  // 创建一个a标签
  let tempLink = document.createElement('a')
  // 隐藏a标签
  tempLink.style.display = 'none'
  tempLink.href = data
  // 给a标签添加下载属性
  tempLink.setAttribute('download', fileName)
  if (typeof tempLink.download === 'undefined') {
    tempLink.setAttribute('target', '_blank')
  }
  // 将a标签添加到body当中
  document.body.appendChild(tempLink)
  // 启动下载
  tempLink.click()
  // 下载完毕删除a标签
  document.body.removeChild(tempLink)
}
export default {
  downloadUrlFile
}
